import { render } from "./AdvisoryRadioGroup.vue?vue&type=template&id=745fe26f"
import script from "./AdvisoryRadioGroup.vue?vue&type=script&lang=js"
export * from "./AdvisoryRadioGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__